import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  useToast
} from '@chakra-ui/react'
import { RefObject, useState } from 'react'

import { TeacherService } from '../../../services/Teacher/TeacherService'
import { Teacher } from '../../../services/Teacher/types'

export interface IDeleteTeacherDialogProps {
  isOpen: boolean
  onClose: () => void
  teacher: Teacher
  leastDestructiveRef: RefObject<HTMLButtonElement>
}

export function TeacherDeleteDialog({ isOpen, onClose, teacher, leastDestructiveRef }: IDeleteTeacherDialogProps) {
  const service = new TeacherService()
  const [isLoading, setIsLoading] = useState(false)
  const toast = useToast()

  const handleDelete = async () => {
    setIsLoading(true)
    try {
      await service.delete(teacher.id)

      toast({
        title: 'Professor excluído com sucesso',
        status: 'success',
        duration: 5000,
        isClosable: true
      })

      onClose()
    } catch (error) {
      toast({
        title: 'Erro ao excluir professor',
        status: 'error',
        duration: 5000,
        isClosable: true
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <AlertDialog isOpen={isOpen} leastDestructiveRef={leastDestructiveRef} onClose={onClose} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Excluir Professor
          </AlertDialogHeader>

          <AlertDialogBody>
            Tem certeza de que deseja excluir o professor <strong>{teacher.name}</strong>?
            <br />
            Esta ação não pode ser desfeita.
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={leastDestructiveRef} onClick={onClose}>
              Cancelar
            </Button>
            <Button colorScheme="red" onClick={handleDelete} ml={3} isLoading={isLoading}>
              Excluir
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}
